import styled from 'styled-components'

import { Field } from '../../Field'

export const DataFieldStyled = styled(Field)`
  .value-container {
    font-size: ${(props) =>
      props.theme.typography.pxToRem(props.theme.fontSizes.body1)};
  }
`
